export default __webpack_public_path__ + "static/media/audi.92da50f5.png";